import { Directive } from '@angular/core'

import { ThemeComponent } from '@flowx/core-theme'

import { FlxComponentThemeBaseDirective } from './component-theme-base.directive'

import { ComponentType } from '../injectors'

@Directive({
  selector: 'flx-modal',
  hostDirectives: [FlxComponentThemeBaseDirective],
  providers: [
    { provide: ComponentType, useValue: [ThemeComponent.Modal, ThemeComponent.ModalHeader] },
  ],
})
export class FlxModalThemeDirective {}
